import { useQuery } from "react-query";
import { fetchProfessionals } from "../../../../api-services/professionals";

export const PROFESSIONALS_QUERY_KEY = "professionals";

export const useProfessionals = () => {
  return useQuery(PROFESSIONALS_QUERY_KEY, fetchProfessionals);
};
